<template>
  <div></div>
</template>
<script>
export default {
  name: "Notification",
}
</script>